module.exports = __webpack_public_path__ + "img/00049.3c265497.webp";